import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';
import _ from 'lodash';

import AxiosService from '../../utils/axios-service';
import { getCampaignId } from '../../selectors/campaign-selectors';
import { getCampaignPermission, deleteCampaignPermission } from '../../utils/jsonapi-functions/campaign-permissions';
import { removeCampaignPermissionFromCampaign, getCampaignDiscussions, removePendingInviationFromCampaign } from '../../utils/jsonapi-functions/campaigns';
import { removeMemberFromDiscussion } from '../../utils/jsonapi-functions/discussions';
import { getCampaignInvitation, deleteCampaignInvitation } from '../../utils/jsonapi-functions/campaign-invitations';
import { reportError } from '../../utils/error-handling-service';

import {
  REMOVE_MEMBER,
  REMOVE_PENDING_MEMBER,
  REMOVE_MEMBER_ERROR,
  REMOVE_MEMBER_SUCCESS,
  REMOVE_PENDING_MEMBER_SUCCESS,
} from './constants';

export function* removePendingMember(action) {
  const invitationId = action.invitationId;
  const campaignId = yield select(getCampaignId);

  try {
    const campaignInvitation = yield call(getCampaignInvitation, invitationId);
    const campaignInvitationJSON = campaignInvitation.toJSONTree();

    yield call(removePendingInviationFromCampaign, campaignId, campaignInvitation);

    yield call(deleteCampaignInvitation, campaignInvitation);

    yield put({
      type: REMOVE_PENDING_MEMBER_SUCCESS,
      organisationId: campaignInvitationJSON.organisation.id,
      invitationId: campaignInvitationJSON.id,
    });
  } catch (error) {
    reportError('REMOVE_CAMPAIGN_INVITATION_ERROR', error.message);
    yield put({ type: REMOVE_MEMBER_ERROR, error });
  }
}

export function* removeMember(action) {
  const permissionId = action.permissionId;
  const userId = action.userId;

  try {
    const campaignId = yield select(getCampaignId);
    const discussions = yield call(getCampaignDiscussions, campaignId);

    const filteredDiscussions = [];

    if (discussions) {
      discussions.forEach(discussion => {
        const discussionMembers = discussion.members;
        const userIsMember = _.find(discussionMembers, discussionMember => {
          return discussionMember.id === permissionId;
        });
        if (userIsMember) filteredDiscussions.push(discussion)
      });
    }

    const campaignPermission = yield call(getCampaignPermission, permissionId);

    for (let x = 0; x < filteredDiscussions.length; x++) {
      const sendbirdChannelURL = filteredDiscussions[x].channelURL;
      const id = filteredDiscussions[x].id;

      // Remove user from channel
      yield call(removeMemberFromChannel, sendbirdChannelURL, userId);

      // Remove user from discussion
      yield call(removeMemberFromDiscussion, id, campaignPermission);
    }

    // Remove them from the campaign and delete the permission
    yield call(removeCampaignPermissionFromCampaign, campaignId, campaignPermission);
    yield call(deleteCampaignPermission, campaignPermission);

    // Remove member from members list and success
    yield put({ type: REMOVE_MEMBER_SUCCESS, permissionId });
  } catch (error) {
    reportError('REMOVE_CAMPAIGN_MEMBER_ERROR', error.message);
    yield put({ type: REMOVE_MEMBER_ERROR, error });
  }
}

export function removeMemberFromChannel(channelURL, userId) {
  const axiosService = new AxiosService('https://api.sendbird.com/v3', 3000, { 'Api-Token': process.env.REACT_APP_SENDBIRD_API_TOKEN });

  return axiosService.put(`/group_channels/${channelURL}/leave`, { user_ids: [userId] })
    .then(response => {
      return response;
    });
}

export function* watchRemoveMemberFromCampaign() {
  yield takeLatest(REMOVE_MEMBER, removeMember);
}

export function* watchRemovePendingMemberFromCampaign() {
  yield takeLatest(REMOVE_PENDING_MEMBER, removePendingMember);
}

export default function* campaignMemberManageSagas() {
  yield [
    fork(watchRemoveMemberFromCampaign),
    fork(watchRemovePendingMemberFromCampaign),
  ];
}



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-members-manage/sagas.js
 **/